import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import Image from 'next/image';
import Slider from 'react-slick';

import business from '@/assets/images/icons/business.svg';
import goldBar from '@/assets/images/icons/gold-bar.svg';
import rupee from '@/assets/images/icons/Rupee.svg';
import security from '@/assets/images/icons/security.svg';
import setting from '@/assets/images/icons/setting.svg';
import watch from '@/assets/images/icons/Withdraw-anytime.svg';
import { BannerSettings } from '@/utils/constants/carousel/BannerSettings';

export const BannerCarousel = () => {
  return (
    <section className="bg bg--light investing">
      <div className="info-slider-dg">
        <Slider {...BannerSettings}>
          <div className="info-slider-item">
            <div className="left">
              <h2 className="text--black text--bold section__title-small">
                The Smarter <br />
                <span className="text--regular">Way To </span>
                <span className="text--black text--bold section__title-small">
                  Invest
                </span>{' '}
                <br /> <span className="text--regular">In </span>
                <span className="text--black text--bold section__title-small">
                  eSwarna Digital Gold
                </span>
              </h2>
            </div>
            <div className="right">
              <div className="icon-flex mfone-align-items-stretch">
                <div className="item">
                  <Image
                    style={{ color: undefined }}
                    className="img-fluid"
                    src={rupee}
                    alt="buy as low"
                  />
                  <p className="text--black text--semi title mt-2">
                    Start investing with as low as{' '}
                    <span className="text--bold">Re. 1 </span>
                  </p>
                </div>
                <div className="item">
                  <Image
                    style={{ color: undefined }}
                    className="img-fluid"
                    src={goldBar}
                    alt="sell anytime"
                  />
                  <p className="text--black text--semi title mt-2">
                    eSwarna Digital Gold is{' '}
                    <span className="text--bold">99.9% pure</span>
                  </p>
                </div>
                <div className="item mt-lg-0 mb-0 mt-4">
                  <Image
                    style={{ color: undefined }}
                    className="img-fluid mfone-third-svg-carousel pl-xl-0 pl-1"
                    src={security}
                    alt="24k gold"
                  />
                  <p className="text--black text--semi title mfone-carousel-paragraph mt-2">
                    Your gold is stored safely, securely
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="info-slider-item">
            <div className="left">
              <h2 className="text--black text--bold section__title-small">
                Invest <br />
                <span className="text--regular">In </span>
                <span className="text--black text--bold section__title-small">
                  eSwarna Digital Gold
                </span>
              </h2>
            </div>
            <div className="right">
              <div className="icon-flex mfone-align-items-stretch">
                <div className="item">
                  <Image
                    style={{ color: undefined }}
                    className="img-fluid"
                    src={watch}
                    alt="buy as low"
                  />
                  <p className="text--black text--semi title mt-2">
                    <span className="text--bold">
                      {/* Buy & sell your gold anytime,anywhere */}
                      Anytime, anywhere buy & sell your gold
                    </span>
                  </p>
                </div>
                <div className="item">
                  <Image
                    style={{ color: undefined }}
                    className="img-fluid"
                    src={business}
                    alt="sell anytime"
                  />
                  <p className="text--black text--semi title mt-2">
                    <span className="text--bold">Sell </span>
                    your gold at
                    <span className="text--bold"> live prices</span>
                  </p>
                </div>
                <div className="item mt-lg-0 mb-0 mt-4">
                  <Image
                    style={{ color: undefined }}
                    className="img-fluid mfone-third-svg-carousel pl-md-1 pl-xl-0 pl-2"
                    src={setting}
                    alt="safety icon"
                  />
                  <p className="text--black text--semi title mfone-carousel-paragraph mt-2">
                    Set up <span className="text--bold">SIPs</span> on the app
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Slider>
      </div>
    </section>
  );
};
